import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import localizationConfig from '../configs/LocalizationConfig';

const resources = {
	en: {
		translation: localizationConfig.en,
	},
	es: {
		translation: localizationConfig.es,
	},
	fr: {
		translation: localizationConfig.fr,
	},
};

const missingKeys = [];
let missingKeyTimeout = null;

//simple debounce
function showMissingKeys(isEnglish) {
	clearTimeout(missingKeyTimeout);
	missingKeyTimeout = setTimeout(() => {
		console.log(`missing keys:\n\n${missingKeys.map((stringToShow) => `"${stringToShow}":"${isEnglish ? stringToShow : ''}"`).join(',\n')}`);
	}, 2000);
}

// eslint-disable-next-line import/no-named-as-default-member
i18next.use(LanguageDetector).use(initReactI18next).init({
	resources,
	interpolation: {
		escapeValue: false,
	},
	keySeparator: false,
	nsSeparator: false,
	fallbackLng: false,
	saveMissing: true,
	ns: [],
	missingKeyHandler: (lngs, ns, key, fallbackValue) => {
		console.log(`Missing translation for key "${key}" for language "${lngs}", falling back to "${fallbackValue}"`);

		const stringToShow = key.replace(new RegExp('"', 'g'), '\\"');

		if (missingKeys.indexOf(stringToShow) < 0) {
			missingKeys.push(stringToShow);
			showMissingKeys(lngs[0] === 'en' || lngs[0] === 'en-US');
		}
	},
});

export default i18next;
